<div class="row row-grid align-items-center py-3">
  <app-event
    class="col-md-6 order-md-1 d-flex align-self-stretch cursor-pointer"
    [event]="event"
    *ngFor="let event of events"
  ></app-event>
</div>
